import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Container, Card, Button, Title } from '../styles/GlobalStyles';
import connectingFoodLogo from '../assets/LogoCF_Branco.png';

const ThankYouCard = styled(Card)`
  text-align: center;
  padding: 48px 32px;
  max-width: 600px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 32px 24px;
  }
`;

const LogoImage = styled.img`
  width: 300px;
  height: auto;
  margin-bottom: 24px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const ThankYouTitle = styled(Title)`
  color: #28a745;
  margin-bottom: 24px;
  font-size: 2rem;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const ThankYouMessage = styled.p`
  font-size: 1.1rem;
  color: #495057;
  margin-bottom: 32px;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const CountdownText = styled.p`
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 24px;
`;

const DashboardButton = styled(Button)`
  background: #0d6efd;
  padding: 12px 32px;
  font-size: 1rem;
  
  &:hover {
    background: #0b5ed7;
  }
`;

interface ThankYouProps {
  onReturnToDashboard: () => void;
}

const ThankYou: React.FC<ThankYouProps> = ({ onReturnToDashboard }) => {
  const [countdown, setCountdown] = useState(12);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    
    const startTimer = () => {
      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            onReturnToDashboard();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    };

    startTimer();

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [onReturnToDashboard]);

  return (
    <Container>
      <ThankYouCard>
        <LogoImage src={connectingFoodLogo} alt="Connecting Food" />
        <ThankYouTitle>🎉 Obrigado!</ThankYouTitle>
        <ThankYouMessage>
          Agradecemos pelo preenchimento do formulário. Suas informações foram salvas com sucesso e são muito importantes para nós.
        </ThankYouMessage>
        <CountdownText>
          Você será redirecionado automaticamente para a tela inicial em {countdown} segundos.
        </CountdownText>
        <DashboardButton onClick={onReturnToDashboard}>
          Voltar à Tela inicial
        </DashboardButton>
      </ThankYouCard>
    </Container>
  );
};

export default ThankYou;